export {
  InkPoint,
  InkStroke,
  InkFieldData,
  InkHistoryEntry,
  InkFormData
} from '@authority-labs/api-interfaces';

import { InkFormData, InkStroke } from '@authority-labs/api-interfaces';

const INK_NOTE_PREFIX = 'INK::';

export function createEmptyInkFormData(): InkFormData {
  return { version: 1, fields: {} };
}

/** Build a stable FieldId for a static field */
export function fieldId(
  inspectionKey: string,
  caseKey: string,
  fieldKey: string
): string {
  return `${inspectionKey}:${caseKey}:${fieldKey}`;
}

/** Build a stable FieldId for a dynamic row field (uses row GUID, never index) */
export function dynamicFieldId(
  inspectionKey: string,
  caseKey: string,
  rowGuid: string,
  fieldKey: string
): string {
  return `${inspectionKey}:${caseKey}:${rowGuid}:${fieldKey}`;
}

/** Build a prefix for removing all fields in a dynamic row */
export function rowPrefix(
  inspectionKey: string,
  caseKey: string,
  rowGuid: string
): string {
  return `${inspectionKey}:${caseKey}:${rowGuid}:`;
}

/** Encode ink strokes into a note string */
export function encodeInkNote(strokes: InkStroke[]): string {
  return INK_NOTE_PREFIX + JSON.stringify(strokes);
}

/** Check if a note string contains ink data */
export function isInkNote(noteText: string): boolean {
  return noteText?.startsWith(INK_NOTE_PREFIX) ?? false;
}

/** Decode ink strokes from a note string */
export function decodeInkNote(noteText: string): InkStroke[] {
  if (!isInkNote(noteText)) return [];
  return JSON.parse(noteText.substring(INK_NOTE_PREFIX.length));
}
